// extracted by mini-css-extract-plugin
module.exports = {"container":"TableComponent_container__1RpzG","spinnerContainer":"TableComponent_spinnerContainer__2IdYD"};